<!-- components/typography/ThentiH2.vue -->
<template>
  <div class="text-center mb-16 mt-16">
    <h2 class="text-4xl md:text-5xl font-bold text-white mb-6">
      <slot />
    </h2>
    <div
      v-if="showDivider"
      class="w-24 h-1 bg-gradient-to-r from-thenti-100 to-thenti-900 mx-auto mb-8"
    ></div>
  </div>
</template>

<script setup>
defineProps({
  showDivider: {
    type: Boolean,
    default: true,
  },
})
</script>
